import React from 'react'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import { ApiClientImplementation } from 'infra/api-client/api-client'
import { AuthenticationRepository } from 'repository/repositories/authentication/authentication-repository'
import { ApiRepository } from 'repository/api-repository'
import { RemoteGetPasswordRecoveryCode } from 'service/usecases/get-password-recovery-code/remote-get-password-recovery-code'
import { RemoteChangePassword } from 'service/usecases/change-password/remote-change-password'
import SecretaryPasswordRecovery from 'presentation/secretary/pages/PasswordRecovery'

export default function makeSecretaryPasswordRecovery() {
  const apiClient = new ApiClientImplementation()
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(apiClient)
  )
  const authenticationRepository = new AuthenticationRepository(apiRepository)
  const getPasswordRecoveryCode = new RemoteGetPasswordRecoveryCode(
    authenticationRepository
  )
  const changePassword = new RemoteChangePassword(authenticationRepository)
  return (
    <SecretaryPasswordRecovery
      changePasswordUseCase={changePassword}
      getCodeUseCase={getPasswordRecoveryCode}
    />
  )
}
